import styled, { css } from "styled-components";
import { Atom } from "AppReact";

const template = styled.div`
  ${({ displayState }) => css`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 5px;
    background-color: ${displayState.color};
  `}
`;

export default Atom({ type: 'label', dataType: 'string', template })